/** Turns omnibox input into a URL (adds https://, or searches). */
export function normalizeInput(input: string, searchUrl = 'https://www.google.com/search?q='): string {
  const s = input.trim();
  if (!s) return 'about:blank';
  if (/^(https?:\/\/|about:|data:)/i.test(s)) return s;
  if (/^(javascript|file|chrome|view-source):/i.test(s)) return searchUrl + encodeURIComponent(s);
  const hostLike = /^(localhost|[\w-]+(\.[\w-]+)+|\[[0-9a-f:]+\])(:\d+)?(\/.*)?$/i;
  if (!/\s/.test(s) && hostLike.test(s)) return 'https://' + s;
  return searchUrl + encodeURIComponent(s);
}

/** Text shown in the address bar for a tab URL. */
export function displayUrl(url: string): string {
  if (!url || url === 'about:blank') return '';
  return url;
}

export function originOf(url: string): string {
  try {
    const u = new URL(url);
    return u.protocol === 'http:' || u.protocol === 'https:' ? u.origin : '';
  } catch {
    return '';
  }
}

/** Host for display in prompts ("example.com"). */
export function hostOf(origin: string): string {
  try {
    return new URL(origin).host;
  } catch {
    return origin;
  }
}

export const isSecure = (url: string) => url.startsWith('https://');
